import PropTypes from "prop-types";
import classes from "./SkuCarFitment.module.css";

const SkuCarFitment = (props) => {
  const { brandName, brandImage, models } = props;

  return (
    <li className={classes["sku-car-fitment"]}>
      <div className={classes["sku-car-fitment__brand"]}>
        <div className={classes["sku-car-fitment__brand-img-wrapper"]}>
          <img
            src={brandImage}
            alt={brandName}
            className={classes["sku-car-fitment__brand-img"]}
          />
        </div>
        <p className={classes["sku-car-fitment__brand-name"]}>{brandName}</p>
      </div>
      <table className={classes["sku-car-fitment__models-table"]}>
        <tbody>
          {models.map((model, index) => (
            <tr key={index}>
              <td className={classes["sku-car-fitment__model-name"]}>
                {model.modelName}
              </td>
              <td className={classes["sku-car-fitment__model-year"]}>
                <span className="numeric-content">{model.startYear}</span>-
                <span className="numeric-content">{model.endYear}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </li>
  );
};

export default SkuCarFitment;

SkuCarFitment.propTypes = {
  brandName: PropTypes.string,
  brandImage: PropTypes.string,
  models: PropTypes.arrayOf(
    PropTypes.shape({
      modelId: PropTypes.number,
      modelName: PropTypes.string,
      startYear: PropTypes.number,
      endYear: PropTypes.number,
    })
  ),
};
